/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback, useEffect } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { helpDialogMessages as messages } from '@atlaskit/editor-common/messages';
import AkModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { closeHelpCommand } from '../pm-plugins/commands';
import { getSupportedFormatting } from './formatting';
import Modal from './Modal';
var selector = function selector(states) {
  var _states$helpDialogSta, _states$helpDialogSta2, _states$helpDialogSta3;
  return {
    isVisible: (_states$helpDialogSta = states.helpDialogState) === null || _states$helpDialogSta === void 0 ? void 0 : _states$helpDialogSta.isVisible,
    imageEnabled: (_states$helpDialogSta2 = states.helpDialogState) === null || _states$helpDialogSta2 === void 0 ? void 0 : _states$helpDialogSta2.imageEnabled,
    aiEnabled: (_states$helpDialogSta3 = states.helpDialogState) === null || _states$helpDialogSta3 === void 0 ? void 0 : _states$helpDialogSta3.aiEnabled
  };
};
var HelpDialog = function HelpDialog(_ref) {
  var pluginInjectionApi = _ref.pluginInjectionApi,
    editorView = _ref.editorView,
    quickInsertEnabled = _ref.quickInsertEnabled,
    intl = _ref.intl;
  var _useSharedPluginState = useSharedPluginStateWithSelector(pluginInjectionApi, ['helpDialog'], selector),
    isVisible = _useSharedPluginState.isVisible,
    imageEnabled = _useSharedPluginState.imageEnabled,
    aiEnabled = _useSharedPluginState.aiEnabled;
  var closeDialog = useCallback(function () {
    var tr = editorView.state.tr,
      dispatch = editorView.dispatch;
    closeHelpCommand(tr, dispatch);
  }, [editorView]);
  var handleEsc = useCallback(function (e) {
    if (e.key === 'Escape' && isVisible) {
      closeDialog();
    }
  }, [closeDialog, isVisible]);
  useEffect(function () {
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('keydown', handleEsc);
    return function () {
      // Ignored via go/ees005
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      document.removeEventListener('keydown', handleEsc);
    };
  }, [handleEsc]);
  var formatting = getSupportedFormatting(editorView.state.schema, intl, imageEnabled, quickInsertEnabled, aiEnabled);
  var label = fg('platform_editor_fix_help_modal_header') ? intl.formatMessage(messages.editorHelp) : undefined;
  return jsx(ModalTransition, null, isVisible ? jsx(AkModalDialog, {
    label: label,
    width: "large",
    onClose: closeDialog,
    testId: "help-modal-dialog"
  }, jsx(Modal, {
    formatting: formatting
  })) : null);
};
export default injectIntl(HelpDialog);